<div style="padding: 0;" class="column small-12 small-12 large-12 ">
  <div class="exercice-popup-img-container">
    <div class="exercice-popup-logo">
      <div class="inner">
        <img class="inner-img" [src]="task?.photo | apiasset | defaultAsset:'DEFAULT_IMAGE_4_3' ">
      </div>
    </div>
    <div class="exercice-popup-img"
         [ngStyle]="{backgroundImage: 'url(' + (task?.cover |apiasset | defaultAsset:'DEFAULT_IMAGE_16_9') + ')'}"></div>
  </div>
  <div class="row">
    <div class="column small-12 small-12 large-12">
      <div class="exercice-popup-hr"></div>
      <div class="exercice-popup-txt-container">
        <div class="hp-content-first-txt" *ngIf="scheduledTask.room">{{scheduledTask.room}}</div>
        <div class="hp-content-second-txt">{{scheduledTask.activity}}</div>
        <div class="hp-content-fourth-txt ng-tns-c7-2 ng-star-inserted">
          <div class="hp-hour-2">{{ scheduledTask.start | time }}
            <span class="hp-duration-2">({{scheduledTask.duration}}')</span></div>
          &mdash; <span class="hp-date-2">{{ scheduledTask.start | date }}</span>
        </div>
        <div class="hp-content-third-txt" *ngIf="scheduledTask?.employee">{{scheduledTask.employee}}</div>
      </div>
    </div>
  </div>


  <div class="row" *ngIf="task">
    <div class="column small-12 small-12 large-12">
      <div class="activity-desc">
        <div class="inner">{{task.description}}</div>
      </div>
    </div>
  </div>


  <ng-container *ngIf="!isTvScreen; else screenOptions;">
    <!-- Inform that an active reservation already exists -->
    <div class="booking-footer" *ngIf="!taskStarted && isBooked;">
      <div class="row">
        <div class="column small-12 small-12 large-12">
          <div class="activity-already-booked">{{'YOU_ALREADY_RESERVED_THIS_ACTIVITY' | translate}}</div>
        </div>
      </div>
      <div class="row">
        <div class="column small-12 small-12 large-12 text-center">
          <button class="dialog-btn reservation-cancel-btn" (click)="closeDialog()">{{'QUIT' | translate}}</button>
        </div>
      </div>
    </div>

    <!--Allow to book-->
    <div class="booking-footer" *ngIf="!isBooked && !taskStarted;">
      <div class="row">
        <div class="column small-12 small-12 large-12">
          <div class="exercice-popup-ul-container">
            <div class="exercice-popup-ul-title">
              Places
            </div>
            <select>
              <option *ngFor="let v of numberOfPlaces" [value]="v">{{v}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row action-btn">
        <div class="column small-12 small-12 large-12 text-center">
          <button class="dialog-btn dialog-btn-fill--primary reservation-btn"
                  (click)="book()">{{'BOOK_BTN' | translate }}
          </button>
          <button class="dialog-btn reservation-cancel-btn"
                  (click)="closeDialog()">{{'QUIT' | translate}}</button>
        </div>
      </div>
    </div>

    <!-- Task already started or finished -->
    <div class="booking-footer" *ngIf="taskStarted">
      <div class="row">
        <div class="column small-12 small-12 large-12">
          <div class="activity-already-booked" *ngIf="taskFinished">
            {{'THIS_ACTIVITY_IS_ALREADY_OVER' | translate}}</div>
          <div class="activity-already-booked"
               *ngIf="!taskFinished && taskStarted">
            {{'THIS_ACTIVITY_IS_ALREADY_STARTED' | translate}}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column small-12 small-12 large-12 text-center">
          <button class="dialog-btn reservation-cancel-btn"
                  (click)="closeDialog()">{{'QUIT' | translate}}</button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #screenOptions>
    <div class="activity-already-booked"
         *ngIf="!taskFinished && taskStarted">
      {{'THIS_ACTIVITY_IS_ALREADY_STARTED' | translate}}
    </div>
  </ng-template>
</div>
